import { render } from "./VirtualNumbersList.vue?vue&type=template&id=4ee59022"
import script from "./VirtualNumbersList.vue?vue&type=script&lang=js"
export * from "./VirtualNumbersList.vue?vue&type=script&lang=js"

import "./VirtualNumbersList.vue?vue&type=style&index=0&id=4ee59022&lang=scss"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__